import ThailandAutoComplete from "vue-thailand-address-autocomplete";
import api from "../../services/service_price_item";
import apiMarim from "../../services/service_undefined_v2";
import Swal from "sweetalert2";

export default {
  components: {
    ThailandAutoComplete
  },
  data() {
    return {
      title: "จัดการสินค้า",
      search: "",
      currentPage: 1,
      items_perpage: 10,
      active: 1,
      modal_active: false,
      modal_data: {
        name: "",
        credit_day: 0,
        debt_limit: 0,
        debt_balance: 0,
        telephone: "",
        address: "",
        sub_district: "",
        district: "",
        province: "",
        zipcode: "",
        active_status: ""
      },
      modal_title: "",
      data_list: [],
      menu_active: 0,
      menus: [
        { name: "menu1" },
        { name: "menu2" },
        { name: "menu3" },
        { name: "menu4" },
        { name: "menu5" }
      ],
      group: [],
      data_list_group: [],
      branch: null
    };
  },
  computed: {
    filterData: function() {
      let text = this.search.trim();
      this.currentPage = 1;
      return this.data_list.filter(items => {
        return items.code.indexOf(text) > -1 || items.name.indexOf(text) > -1;
      });
    },
    paginate: function() {
      this.totalItem = this.filterData.length;
      if (this.currentPage >= this.totalPages) {
        this.currentPage = Math.max(0, this.totalPages - 1);
      }
      var index = (this.currentPage - 1) * this.items_perpage;
      return this.filterData.slice(index, index + this.items_perpage);
    }
  },
  methods: {
    itemRender(current, type, originalElement) {
      if (type === "prev") {
        return "Previous";
      } else if (type === "next") {
        return "Next";
      }
      return originalElement;
    },
    onChange(pageNumber) {
      this.active = pageNumber;
    },
    goToPage(path, itemId) {
      this.$store.state.historyPage = this.$route.path;
      this.$router.push({ name: path, params: { id: itemId } });
    },
    doing() {
      alert("รอดำเนินการ");
    },
    select(address) {
      this.modal_data.sub_district = address.district;
      this.modal_data.district = address.amphoe;
      this.modal_data.province = address.province;
      this.modal_data.zipcode = address.zipcode;
    },
    close_modal() {
      this.modal_active = false;
      this.modal_data = {
        name: "",
        credit_day: 0,
        debt_balance: 0,
        telephone: "",
        address: "",
        sub_district: "",
        district: "",
        province: "",
        zipcode: "",
        active_status: ""
      };
    },
    getProductAll() {
      this.$store.state.isLoading = true;
      api.listProduct(
        sessionStorage.Url + "/",
        {
          headers: {
            "Access-Token": sessionStorage.token
          }
        },
        {},
        result => {
          // console.log(result)
          this.$store.state.isLoading = false;
          if (result.response === "success") {
            this.data_list = result.data;
          } else {
            this.data_list = [];
            this.alert_msg("warning", "ดึงข้อมูลสินค้า", result.message);
          }
          this.$store.state.isLoading = false;
        },
        error => {
          this.data_list = [];
          this.$store.state.isLoading = false;
          console.log(error);
          this.alert_msg(
            "error",
            "ไม่สามารถเข้าถึงข้อมูลได้",
            "เชื่อมต่อสาขาไม่ได้"
          );
        }
      );
    },
    editItem(val) {
      console.log(val.id);
      this.goToPage("managepriceitem", val.id);
    },

    deleteItem(val) {
      // this.alert_msg('success', 'ลบข้อมูลสำเร็จ', '')
      // this.$store.commit("Loading");

      Swal.fire({
        title: "ลบข้อมูลสินค้า",
        text: "ท่านต้องการลบข้อมูลสินค้า ใช่หรือไม่ ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ตกลง",
        cancelButtonText: "ปฏิเสธ",
        cancelButtonColor: "red",
        reverseButtons: true
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.commit("Loading");
          apiMarim.deleteProduct(
            {
              item_id: val.id,
              item_code: val.code
            },
            this.header,
            results => {
              if (results.data.status) {
                this.alert_msg("success", "ลบข้อมูลสำเร็จ", "");
                this.getProductAll();
              } else {
                this.alert_msg("warning", "ไม่สามารถเข้าถึงข้อมูล", "");
              }
              this.$store.commit("Loading");
            },
            errors => {
              this.$store.commit("Loading");
              // this.$store.commit("Loading");
              this.alert_msg(
                "warning",
                "ไม่สามารถเข้าถึงข้อมูล",
                errors.message
              );
            }
          );
        }
      });
      // apiMarim.deleteProduct(
      //   {
      //     item_id: val.id,
      //     item_code: val.code
      //   },
      //   this.header,
      //   results => {
      //     if (results.data.status) {
      //       this.alert_msg("success", "ลบข้อมูลสำเร็จ", "");
      //       this.getProductAll();
      //     } else {
      //       this.alert_msg("warning", "ไม่สามารถเข้าถึงข้อมูล", "");
      //     }
      //     this.$store.commit("Loading");
      //   },
      //   errors => {
      //     this.$store.commit("Loading");
      //     // this.$store.commit("Loading");
      //     this.alert_msg("warning", "ไม่สามารถเข้าถึงข้อมูล", errors.message);
      //   }
      // );
      // this.goToPage('managepriceitem', val.id)
    },
    getGroup() {
      api.itemGroup(
        sessionStorage.Url + "/",
        {
          headers: {
            "Access-Token": sessionStorage.token
          }
        },
        {},
        result => {
          this.$store.state.isLoading = false;
          if (result.response === "success") {
            this.group = result.data;
          } else {
            this.group = [];
            this.alert_msg(
              "warning",
              "ดึงข้อมูลกลุ่มสินค้าไม่ได้",
              result.message
            );
          }
        },
        error => {
          this.$store.state.isLoading = false;
          this.group = [];
          console.log(error);
          this.alert_msg(
            "error",
            "ไม่สามารถเข้าถึงข้อมูลได้",
            "เชื่อมต่อสาขาไม่ได้"
          );
        }
      );
    },
    ListByGroup() {
      this.$store.state.isLoading = true;
      api.itemsALLGroup(
        sessionStorage.Url + "/",
        {
          headers: {
            "Access-Token": sessionStorage.token
          }
        },
        { keyword: "" },
        result => {
          this.$store.state.isLoading = false;
          if (result.response === "success") {
            this.data_list_group = result.data;
          } else {
            this.data_list_group = [];
            this.alert_msg("warning", "ดึงข้อมูลสินค้า", result.message);
          }
        },
        error => {
          this.$store.state.isLoading = false;
          this.data_list_group = [];
          console.log(error);
          this.alert_msg(
            "error",
            "ไม่สามารถเข้าถึงข้อมูลได้",
            "เชื่อมต่อสาขาไม่ได้"
          );
        }
      );
    },
    selectByGroup(index) {
      this.data_list = this.data_list_group[index].items;
      if (this.data_list_group[index].items == null) {
        this.data_list = [];
      } else {
        this.data_list = this.data_list_group[index].items;
      }
    }
  },
  mounted() {
    this.checkUser();
    // this.getBranch()
    setTimeout(() => {
      // this.branch = this.$store.state.branch_list[0]
      // this.getGroup()
      // this.ListByGroup()
      this.getProductAll();
    }, 1000);
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/item_price_list.js